{
    "component-card-search-list.empty-state.title.non-final": "<strong>Liên kết kho này với một thành phần phần mềm</strong>",
    "component-card.add-chat-channel": "Thêm kênh trò chuyện",
    "component-card.chat-channels": "Kênh trò chuyện",
    "component-card.expander.show-more-link": "Hiển thị {formattedCount} thành phần khác"
}
